module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nconst fieldConfig           = model.config || {}\nconst managementConfig      = fieldConfig.managementConfig || {}\nconst buttonNeutral         = fieldConfig.style === 'neutral'\nconst single                = managementConfig.multiSelect === false || managementConfig.maxNrOfElements == 1\n// TODO: is this disabled feature even in use anywhere?\nlet disabled = false;\nif(!!formMapping && !!formMapping.fieldConfig) {\ndisabled = !!formMapping.fieldConfig.disabled;\n}\nconst additionalClasses = []\nif(disabled)                    additionalClasses.push('disabled');\nif(model.fullScreen)            additionalClasses.push('fullScreen');\nif(model.isDirty)               additionalClasses.push('isDirty');\nif(fieldConfig.slim)            additionalClasses.push('slim');\nif(single)                      additionalClasses.push('single');\nif(fieldConfig.style)           additionalClasses.push(fieldConfig.style);\nconst nrOfFiles = utils.collectionSize(model.dataJSON)\nconst preventFiles = fieldConfig.showFiles === false && !model.fullScreen\nlet fullScreenButtonType = 'fullScreen'\nif(model.fullScreen){\nfullScreenButtonType = 'closeFullScreen'\n}\nconst controls = {\nassign:         !preventFiles,\nassignFiltered: !preventFiles && model.extendedButtonActionsGranted && !fieldConfig.instantUpload,\ndelete:         !preventFiles,\nfullScreen:     !fieldConfig.slim,\n}\n%><div data-field-code=\"<%- model.fieldCode || '' %>\" class=\"<%= additionalClasses.join(' '); %>\"><%\nif(fieldConfig.showInlineInformation && model.information){\n%><p class=\"information labelLike\"><%- model.information %></p><%\n}\n%><div class=\"controls\"><%\nif(controls.assign){\nconst buttonFormMapping = formMapping\nbuttonFormMapping.neutral = buttonNeutral\n%><%- include('./file-button', { formMapping: buttonFormMapping, model: model, config: config }); %><%\n}\nif(controls.assignFiltered){\n%><%- include('../elements/buttons/default', { formMapping: { buttonType: 'filter', context: 'media-file', symbolOnly: !model.fullScreen, neutral: buttonNeutral } }); %><%\n}\nif(controls.delete){\n%><%- include('../elements/buttons/default', { formMapping: { buttonType: 'delete', context: 'media-file', symbolOnly: !model.fullScreen, neutral: buttonNeutral } }); %><%\n}\nif(controls.fullScreen){\n%><%- include('../elements/buttons/default', { formMapping: { buttonType: fullScreenButtonType, context: 'media-file', symbolOnly: !model.fullScreen, neutral: buttonNeutral } }); %><%\n}\n%></div><%\nif(!fieldConfig.slim){\n%><div class=\"notices\"><%\n%><div class=\"notice dirty\"><%= storage.__('hint.fileField.dirty') %></div><%\nif(nrOfFiles <= 0) {\n%><div class=\"notice\"><%= storage.__('hint.fileField.empty') %></div><%\n} else if(preventFiles) {\n%><div class=\"notice\"><%= storage.__('hint.fileField.hiddenFiles', { nrOfElements: nrOfFiles }) %></div><%\n}\n%></div><%\n}\n%><div class=\"mediaContainer\"><%\n%><div class=\"media\"><%\nif(!preventFiles){\nif(nrOfFiles > 0) {\nfor(const file of Object.values(model.dataJSON || {})){\n%><%- include('../media/file/file', { resourceData: file, config: { context: 'assignment', slimControls: fieldConfig.slimControls }, formMapping: formMapping }); %><%\n}\n} else if(fieldConfig.slim) {\n%><%- include('../media/file/file', { resourceData: {}, config: { context: 'assignment' }, formMapping: formMapping }); %><%\n}\n}\n%></div><%\n%></div><%\n%></div>"
  , __filename = "..\\frontend-controller\\baseComponents\\form\\fields\\file.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
const fieldConfig           = model.config || {}
const managementConfig      = fieldConfig.managementConfig || {}
const buttonNeutral         = fieldConfig.style === 'neutral'
const single                = managementConfig.multiSelect === false || managementConfig.maxNrOfElements == 1
// TODO: is this disabled feature even in use anywhere?
let disabled = false;
if(!!formMapping && !!formMapping.fieldConfig) {
disabled = !!formMapping.fieldConfig.disabled;
}
const additionalClasses = []
if(disabled)                    additionalClasses.push('disabled');
if(model.fullScreen)            additionalClasses.push('fullScreen');
if(model.isDirty)               additionalClasses.push('isDirty');
if(fieldConfig.slim)            additionalClasses.push('slim');
if(single)                      additionalClasses.push('single');
if(fieldConfig.style)           additionalClasses.push(fieldConfig.style);
const nrOfFiles = utils.collectionSize(model.dataJSON)
const preventFiles = fieldConfig.showFiles === false && !model.fullScreen
let fullScreenButtonType = 'fullScreen'
if(model.fullScreen){
fullScreenButtonType = 'closeFullScreen'
}
const controls = {
assign:         !preventFiles,
assignFiltered: !preventFiles && model.extendedButtonActionsGranted && !fieldConfig.instantUpload,
delete:         !preventFiles,
fullScreen:     !fieldConfig.slim,
}

    ; __line = 30
    ; __append("<div data-field-code=\"")
    ; __append( model.fieldCode || '' )
    ; __append("\" class=\"")
    ; __append(escapeFn( additionalClasses.join(' ') ))
    ; __append("\">")
    ; 
if(fieldConfig.showInlineInformation && model.information){

    ; __line = 32
    ; __append("<p class=\"information labelLike\">")
    ; __append( model.information )
    ; __append("</p>")
    ; 
}

    ; __line = 34
    ; __append("<div class=\"controls\">")
    ; 
if(controls.assign){
const buttonFormMapping = formMapping
buttonFormMapping.neutral = buttonNeutral

    ; __line = 38
    ; __append( include('./file-button', { formMapping: buttonFormMapping, model: model, config: config }) )
    ; 
}
if(controls.assignFiltered){

    ; __line = 41
    ; __append( include('../elements/buttons/default', { formMapping: { buttonType: 'filter', context: 'media-file', symbolOnly: !model.fullScreen, neutral: buttonNeutral } }) )
    ; 
}
if(controls.delete){

    ; __line = 44
    ; __append( include('../elements/buttons/default', { formMapping: { buttonType: 'delete', context: 'media-file', symbolOnly: !model.fullScreen, neutral: buttonNeutral } }) )
    ; 
}
if(controls.fullScreen){

    ; __line = 47
    ; __append( include('../elements/buttons/default', { formMapping: { buttonType: fullScreenButtonType, context: 'media-file', symbolOnly: !model.fullScreen, neutral: buttonNeutral } }) )
    ; 
}

    ; __line = 49
    ; __append("</div>")
    ; 
if(!fieldConfig.slim){

    ; __line = 51
    ; __append("<div class=\"notices\">")
    ; 

    ; __line = 52
    ; __append("<div class=\"notice dirty\">")
    ; __append(escapeFn( storage.__('hint.fileField.dirty') ))
    ; __append("</div>")
    ; 
if(nrOfFiles <= 0) {

    ; __line = 54
    ; __append("<div class=\"notice\">")
    ; __append(escapeFn( storage.__('hint.fileField.empty') ))
    ; __append("</div>")
    ; 
} else if(preventFiles) {

    ; __line = 56
    ; __append("<div class=\"notice\">")
    ; __append(escapeFn( storage.__('hint.fileField.hiddenFiles', { nrOfElements: nrOfFiles }) ))
    ; __append("</div>")
    ; 
}

    ; __line = 58
    ; __append("</div>")
    ; 
}

    ; __line = 60
    ; __append("<div class=\"mediaContainer\">")
    ; 

    ; __line = 61
    ; __append("<div class=\"media\">")
    ; 
if(!preventFiles){
if(nrOfFiles > 0) {
for(const file of Object.values(model.dataJSON || {})){

    ; __line = 65
    ; __append( include('../media/file/file', { resourceData: file, config: { context: 'assignment', slimControls: fieldConfig.slimControls }, formMapping: formMapping }) )
    ; 
}
} else if(fieldConfig.slim) {

    ; __line = 68
    ; __append( include('../media/file/file', { resourceData: {}, config: { context: 'assignment' }, formMapping: formMapping }) )
    ; 
}
}

    ; __line = 71
    ; __append("</div>")
    ; 

    ; __line = 72
    ; __append("</div>")
    ; 

    ; __line = 73
    ; __append("</div>")
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=..\frontend-controller\baseComponents\form\fields\file.ejs

}